export default function CustomerInformation({ customer }) {
  return (
    <div className="w-full pb-6 bg-white rounded-xl shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)] outline outline-1 outline-offset-[-1px] outline-slate-200 flex flex-col justify-start items-center gap-6 overflow-hidden">
      <div className="self-stretch px-6 py-4 bg-slate-50 border-b border-slate-200 flex flex-col justify-start items-start">
        <div className="self-stretch flex flex-col justify-start items-start">
          <div className="self-stretch justify-center text-slate-800 text-sm font-InterBold uppercase leading-5 tracking-wide">
            Customer Information
          </div>
        </div>
      </div>
      <div className="w-full flex justify-between items-start gap-4 px-[24px]">
        <div className="flex-1 min-w-0 self-stretch inline-flex flex-col justify-start items-start gap-1 bg-red">
          <div className="justify-center text-slate-400 text-xs font-InterBold uppercase leading-4 tracking-tight">
            Company
          </div>
          <div className="self-stretch flex flex-col justify-start items-start">
            <div className="self-stretch justify-center text-slate-700 text-sm font-InterSemiBold leading-5 break-words">
              {customer.companyName || "—"}
            </div>
          </div>
        </div>
        <div className="flex-1 min-w-0 self-stretch inline-flex flex-col justify-start items-start gap-1">
          <div className="justify-center text-slate-400 text-xs font-InterBold uppercase leading-4 tracking-tight">
            Email
          </div>
          <div className="self-stretch flex flex-col justify-start items-start">
            <div className="self-stretch justify-center text-slate-500 text-sm font-InterMedium leading-5 break-all">
              {customer.email || "—"}
            </div>
          </div>
        </div>
        <div className="flex-1 min-w-0 self-stretch inline-flex flex-col justify-start items-start gap-1">
          <div className="justify-center text-slate-400 text-xs font-InterBold uppercase leading-4 tracking-tight">
            Contact
          </div>
          <div className="self-stretch flex flex-col justify-start items-start">
            <div className="self-stretch justify-center text-slate-500 text-sm font-InterMedium leading-5 break-words">
              {customer.contact || "—"}
            </div>
          </div>
        </div>
        <div className="flex-1 min-w-0 self-stretch inline-flex flex-col justify-start items-start gap-1">
          <div className="w-30 justify-center text-slate-400 text-xs font-InterBold uppercase leading-4">
            Phone Number
          </div>
          <div className="self-stretch flex flex-col justify-start items-start">
            <div className="self-stretch justify-center text-slate-500 text-sm font-InterMedium leading-5 break-words">
              {customer.phone || "—"}
            </div>
          </div>
        </div>
        <div className="flex-1 min-w-0 self-stretch inline-flex flex-col justify-start items-start gap-[2.88px]">
          <div className="justify-center text-slate-400 text-xs font-InterBold uppercase leading-4 tracking-tight">
            Address
          </div>
          <div className="self-stretch pb-[0.63px] flex flex-col justify-start items-start">
            <div className="self-stretch justify-center text-slate-700 text-sm font-InterSemiBold leading-6 break-words">
              {customer.address || "—"}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
